const parseKey = (key: string) => key.split(/[;/]/);

export default parseKey;
